import { focusAtom } from "jotai-optics"
import { PhotoId, stateAtom } from "./undoable-state"
import { PhotoRecord } from "@/lib/catalog"
import { store } from "./store"
import { filePathsAtom } from "./photo/photos-state"
import { projectAtom } from "./project/projects-state"

export const filesAtom = focusAtom(stateAtom, (optic) => optic.prop("files"))

export const getFileForPhoto = (photoOrId: PhotoId | PhotoRecord) => {
	const files = store.get(filesAtom)

	if (typeof photoOrId === "string") {
		return files[photoOrId]
	} else {
		return files[photoOrId.id]
	}
}

export async function getFileForPhotoFromOpfsIfNeeded(
	photo: PhotoRecord,
): Promise<File | undefined> {
	const project = store.get(projectAtom)
	if (!project?.isSampleProject) {
		return undefined
	}

	const storageRoot = await navigator.storage?.getDirectory?.()
	if (!storageRoot) {
		return undefined
	}

	const paths = store.get(filePathsAtom)
	const relativePath = paths[photo.parentId ?? photo.id]
	if (!relativePath) {
		return undefined
	}

	const segments = relativePath.split("/").filter(Boolean)

	try {
		let directory: FileSystemDirectoryHandle = storageRoot
		for (const segment of segments) {
			directory = await directory.getDirectoryHandle(segment, { create: false })
		}
		const handle = await directory.getFileHandle(photo.fileName, { create: false })
		const file = await handle.getFile()

		const files = store.get(filesAtom)
		store.set(filesAtom, { ...files, [photo.id]: file })
		return file
	} catch (error) {
		console.warn("[SampleProject] Failed to resolve file from OPFS", error)
		return undefined
	}
}
